import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const featuredImageUrls: Record<string, string> = {
  'nana-lite-launch': 'https://readdy.ai/api/search-image?query=Minimalist%20lightweight%20app%20on%20a%20clean%20white%20desk%20with%20soft%20natural%20lighting%2C%20elegant%20and%20simple%20design%2C%20warm%20cream%20background%2C%20editorial%20product%20photography%20with%20gentle%20shadows&width=800&height=400&seq=article-launch&orientation=landscape',
  'boost-productivity-with-nana-lite': 'https://readdy.ai/api/search-image?query=Modern%20workspace%20with%20laptop%20showing%20minimalist%20productivity%20app%20interface%2C%20warm%20ambient%20lighting%2C%20clean%20desk%20setup%20with%20notebook%20and%20coffee%2C%20soft%20cream%20and%20wood%20tones&width=800&height=400&seq=article-productivity&orientation=landscape',
  'lite-vs-full-comparison': 'https://readdy.ai/api/search-image?query=Side%20by%20side%20comparison%20of%20two%20smartphone%20app%20interfaces%2C%20one%20minimalist%20one%20comprehensive%2C%20clean%20white%20background%2C%20soft%20shadow%2C%20modern%20UI%20design%20aesthetic&width=800&height=400&seq=article-comparison&orientation=landscape',
};

const featuredArticles = articles.slice(0, 3);

export default function ArticlesSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold font-heading text-foreground-950">
              精选<span className="text-primary-500">文章</span>
            </h2>
            <p className="mt-2 text-sm text-foreground-600">了解更多关于轻量化效率的知识</p>
          </div>
          <Link
            to="/category/all"
            className="hidden sm:flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {featuredArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group block rounded-2xl bg-background-100 overflow-hidden border border-background-200/70 hover:border-primary-200/60 transition-colors duration-200"
            >
              <div className="h-48 overflow-hidden">
                <img
                  src={featuredImageUrls[article.slug]}
                  alt={article.title}
                  title={`${article.title} - 娜娜轻量版`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-xs text-foreground-500">{article.date}</span>
                  <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700">
                    {article.readTime}
                  </span>
                </div>
                <h3 className="text-base font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">{article.excerpt}</p>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors"
          >
            查看全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}